// extracted by mini-css-extract-plugin
export default {"container":"qhrhJVBNR8i0bnL18ZQn","input":"FiKMB9kxM1EdSyjPR0Pe","icon":"jlkd326aO0Mot2MTGKwQ","label":"O3C_S2VCoNXAMvY3nZ7A"};